// extracted by mini-css-extract-plugin
export default {"content":"Note-module__content__QKR5o","text":"Note-module__text__0OMSE"};